// Kratos Defense Theme JavaScript

// Header scroll effect
window.addEventListener('scroll', function() {
  const header = document.querySelector('.header-wrapper');
  if (header) {
    if (window.scrollY > 50) {
      header.classList.add('scrolled-active');
    } else {
      header.classList.remove('scrolled-active');
    }
  }
});

// Product image switcher
document.querySelectorAll('.product__thumbnail').forEach(function(thumbnail) {
  thumbnail.addEventListener('click', function() {
    const mainImage = document.querySelector('.product__image');
    if (mainImage) {
      mainImage.src = this.getAttribute('data-image');
    }
  });
});

// Add to cart functionality (basic)
document.addEventListener('submit', function(e) {
  if (e.target.matches('[action*="/cart/add"]')) {
    // You can add AJAX cart functionality here
  }
});
